import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { StandardWheelEvent } from '../../mouseEvent.js';
import { AbstractScrollbar } from './abstractScrollbar.js';
import { ARROW_IMG_SIZE } from './scrollbarArrow.js';
import { ScrollbarState } from './scrollbarState.js';
import { Codicon, registerIcon } from '../../../common/codicons.js';
var scrollbarButtonUpIcon = registerIcon('scrollbar-button-up', Codicon.triangleUp);
var scrollbarButtonDownIcon = registerIcon('scrollbar-button-down', Codicon.triangleDown);
export var VerticalScrollbar = /*#__PURE__*/function (_AbstractScrollbar) {
  _inherits(VerticalScrollbar, _AbstractScrollbar);

  var _super = _createSuper(VerticalScrollbar);

  function VerticalScrollbar(scrollable, options, host) {
    var _this;

    _classCallCheck(this, VerticalScrollbar);

    var scrollDimensions = scrollable.getScrollDimensions();
    var scrollPosition = scrollable.getCurrentScrollPosition();
    _this = _super.call(this, {
      lazyRender: options.lazyRender,
      host: host,
      scrollbarState: new ScrollbarState(options.verticalHasArrows ? options.arrowSize : 0, options.vertical === 2
      /* Hidden */
      ? 0 : options.verticalScrollbarSize, // give priority to vertical scroll bar over horizontal and let it scroll all the way to the bottom
      0, scrollDimensions.height, scrollDimensions.scrollHeight, scrollPosition.scrollTop),
      visibility: options.vertical,
      extraScrollbarClassName: 'vertical',
      scrollable: scrollable
    });

    if (options.verticalHasArrows) {
      var arrowDelta = (options.arrowSize - ARROW_IMG_SIZE) / 2;
      var scrollbarDelta = (options.verticalScrollbarSize - ARROW_IMG_SIZE) / 2;

      _this._createArrow({
        className: 'scra',
        icon: scrollbarButtonUpIcon,
        top: arrowDelta,
        left: scrollbarDelta,
        bottom: undefined,
        right: undefined,
        bgWidth: options.verticalScrollbarSize,
        bgHeight: options.arrowSize,
        onActivate: function onActivate() {
          return _this._host.onMouseWheel(new StandardWheelEvent(null, 0, 1));
        }
      });

      _this._createArrow({
        className: 'scra',
        icon: scrollbarButtonDownIcon,
        top: undefined,
        left: scrollbarDelta,
        bottom: arrowDelta,
        right: undefined,
        bgWidth: options.verticalScrollbarSize,
        bgHeight: options.arrowSize,
        onActivate: function onActivate() {
          return _this._host.onMouseWheel(new StandardWheelEvent(null, 0, -1));
        }
      });
    }

    _this._createSlider(0, Math.floor((options.verticalScrollbarSize - options.verticalSliderSize) / 2), options.verticalSliderSize, undefined);

    return _this;
  }

  _createClass(VerticalScrollbar, [{
    key: "_updateSlider",
    value: function _updateSlider(sliderSize, sliderPosition) {
      this.slider.setHeight(sliderSize);
      this.slider.setTop(sliderPosition);
    }
  }, {
    key: "_renderDomNode",
    value: function _renderDomNode(largeSize, smallSize) {
      this.domNode.setWidth(smallSize);
      this.domNode.setHeight(largeSize);
      this.domNode.setRight(0);
      this.domNode.setTop(0);
    }
  }, {
    key: "onDidScroll",
    value: function onDidScroll(e) {
      this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender;
      this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender;
      this._shouldRender = this._onElementSize(e.height) || this._shouldRender;
      return this._shouldRender;
    }
  }, {
    key: "_mouseDownRelativePosition",
    value: function _mouseDownRelativePosition(offsetX, offsetY) {
      return offsetY;
    }
  }, {
    key: "_sliderMousePosition",
    value: function _sliderMousePosition(e) {
      return e.posy;
    }
  }, {
    key: "_sliderOrthogonalMousePosition",
    value: function _sliderOrthogonalMousePosition(e) {
      return e.posx;
    }
  }, {
    key: "_updateScrollbarSize",
    value: function _updateScrollbarSize(size) {
      this.slider.setWidth(size);
    }
  }, {
    key: "writeScrollPosition",
    value: function writeScrollPosition(target, scrollPosition) {
      target.scrollTop = scrollPosition;
    }
  }]);

  return VerticalScrollbar;
}(AbstractScrollbar);